export default "__VITE_ASSET__12821302__"